/**
 * Created by babu on 12/05/16.
 */


var Targe = {
    code: 1,
    name: "目的地"
};

var More = {
    code: 2,
    name: "更多筛选"
};
var Sort = {
    code: 3,
    name: "排序"
};

module.exports = {
    Targe,
    More,
    Sort,
    list: [Targe, More, Sort]
};


/** WEBPACK FOOTER **
 ** ./script/conf/filter-type.js
 **/